<template>
    <vs-popup class="holamundo add-variant-popup" :class="{'has-changes': hasChanges, 'queue-process': isVariationOverlay && item.coobo_library_link_priority_queue && (item.coobo_library_link_priority_queue.status != 'done' && (!item.coobo_library_link_priority_queue.data || !item.coobo_library_link_priority_queue.data.status || !item.coobo_library_link_priority_queue.data.status.success) )}" :title="(edit_item ? 'Edit' : 'Add') + ' a variation'"
              :active.sync="popupActive" v-if="item">
      <processing-asset :variation="item" :cancel="cancel" :getVariantData="getVariantData" v-if="isVariationOverlay && item.coobo_library_link_priority_queue && (item.coobo_library_link_priority_queue.status != 'done' && (!item.coobo_library_link_priority_queue.data || !item.coobo_library_link_priority_queue.data.status || !item.coobo_library_link_priority_queue.data.status.success) )"></processing-asset>

      <div ref="scroll" class="scroll"  :class="{'no-edit': $store.state.user.role.name === 'Media' && asset.published_variant === item._id && asset.published}">
          <div class="vx-row">
              <div class="vx-col w-full sm:w-full md:w-1/2" :class="{'no-edit': $store.state.user.role.name === 'CopyEditors'}">
                  <vx-input-group class="mb-4 custom-input-group">
                      <template slot="prepend">
                          <div class="label-with-tooltip">
                              <div class="prepend-text bg-dark">
                                  Variation name
                              </div>
                              <vx-tooltip
                                      class="help-tip"
                                      position="right"
                                      text="Example: High-poly source, red apple, green apple, apple dropped">
                                  <i class="material-icons notranslate"> help_outline </i>
                              </vx-tooltip>
                          </div>
                      </template>

                      <div class="d-flex">
                          <vs-input
                                  name="name"
                                  v-validate="'required'"
                                  placeholder="Name"
                                  v-model="item.name"
                          />
                          <span class="text-danger text-sm validation-error" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                      </div>
                  </vx-input-group>
              </div>
              <div class="vx-col w-full sm:w-full md:w-1/2" :class="{'no-edit': $store.state.user.role.name === 'CopyEditors'}">
                  <vx-input-group class="mb-4 custom-input-group">
                      <template slot="prepend">
                          <div class="label-with-tooltip">
                              <div class="prepend-text bg-dark" style="line-height: 1">
                                  Variation <br/> description
                              </div>
                              <vx-tooltip
                                      class="help-tip"
                                      position="right"
                                      text="Variation description">
                                  <i class="material-icons notranslate"> help_outline </i>
                              </vx-tooltip>
                          </div>
                      </template>

                      <div class="d-flex">
                          <vs-input

                                  name="description"
                                  placeholder="Description"
                                  v-model="item.description"
                          />
                          <span class="text-danger text-sm validation-error" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                      </div>
                  </vx-input-group>
              </div>
          </div>
          <div class="vx-row">
              <div class="vx-col w-full sm:w-full md:w-1/2" :class="{'no-edit': $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors'}">
                  <vx-input-group class="mb-4 custom-input-group">
                      <template slot="prepend">
                          <div class="label-with-tooltip">
                              <div class="prepend-text bg-dark">
                                  Type
                              </div>
                              <vx-tooltip
                                  class="help-tip"
                                  position="right"
                                  text="Texture/vray material/Final render">
                                  <i class="material-icons notranslate"> help_outline </i>
                              </vx-tooltip>
                          </div>
                      </template>

                      <div class="d-flex">
                          <vs-input
                              name="name"
                              placeholder="Type"
                              v-model="item.variant_type"
                          />
                          <span class="text-danger text-sm validation-error" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                      </div>
                  </vx-input-group>
              </div>
              <div class="vx-col w-full sm:w-full md:w-1/2" :class="{'no-edit': $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors'}">
                  <vx-input-group class="custom-input-group">
                      <template slot="prepend">
                          <div class="label-with-tooltip">
                              <div class="prepend-text bg-dark">
                                  Notes
                              </div>
                              <vx-tooltip
                                  class="help-tip"
                                  position="right"
                                  text="Additional notes that might help with tracking the asset, such as Jira CAC numbers or special instructions">
                                  <i class="material-icons notranslate"> help_outline </i>
                              </vx-tooltip>
                          </div>
                      </template>

                      <div class="d-flex">
                          <vs-textarea
                              class="resize-vertical min-h-60"
                              name="name"
                              placeholder="Write your notes..."
                              v-model="item.notes"
                          />
                      </div>

                  </vx-input-group>
              </div>
              <div class="vx-col w-full sm:w-full lg:w-1/2" :class="{'no-edit': $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors'}">
                  <vx-input-group class="custom-input-group">
                      <template slot="prepend">
                          <div class="label-with-tooltip">
                              <div class="prepend-text bg-dark">
                                  Visual style
                              </div>
                              <vx-tooltip
                                  class="help-tip"
                                  position="right"
                                  text="<div>Graphical style of the asset variant.</div><img src='/img/tooltip.png' />">
                                  <i class="material-icons notranslate"> help_outline </i>
                              </vx-tooltip>
                          </div>
                      </template>
                      <div class="d-flex">
                          <div class="vx-input-group-append flex-grow">
                              <div class="append-text btn-addon">
                                  <vs-button
                                      color="primary"
                                      type="border"
                                      v-for="(v, i) in visualStyles"
                                      :key="i"
                                      @click="item.visual_style = v.name"
                                      class="radiobtn"
                                      :class="{selected: item.visual_style === v.name}">
                                      {{v.name}}
                                  </vs-button>
                              </div>
                          </div>
                          <span class="text-danger text-sm validation-error"
                                v-show="errors.has('visual_style')">{{ errors.first('visual_style') }}</span>
                      </div>
                  </vx-input-group>
              </div>
              <div class="vx-col w-full sm:w-full lg:w-1/2">
                  <vx-input-group class="custom-input-group mb-4 variation-select">
                      <template slot="prepend">
                          <div class="label-with-tooltip">
                              <div class="prepend-text bg-dark">
                                  Language
                              </div>
                              <vx-tooltip
                                  class="help-tip"
                                  position="right"
                                  text="Any visible text in the media file, if no text is visible, select None. This is useful for translation">
                                  <i class="material-icons notranslate"> help_outline </i>
                              </vx-tooltip>
                          </div>
                      </template>
                      <div class="vx-input-group-append d-flex">
                        <v-select
                          ref="currentLanguage"
                          class="hide-search break-word"
                          name="currentLanguage"
                          :options="[{ name: 'None', code: 'none' }, { name: 'English', code: 'en' }, ...$store.state.languages]"
                          v-model="currentLanguage"
                          @input="changeLanguage"
                          label="name"
                          :searchable="false"
                          :clearable="false"
                          style="width: 150px; height: 38px;"
                          :reduce="item => item"/>
                      </div>
                  </vx-input-group>
              </div>
            </div>
          <div :class="{'no-edit': $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors'}">
            <vx-input-group class="mb-4 custom-input-group upload-block">
                <template slot="prepend">
                    <div class="label-with-tooltip" style="align-items: center">
                        <div class="prepend-text bg-dark" style="padding: .7rem !important;">
                            Upload thumbnail
                        </div>
                        <vx-tooltip
                            class="help-tip"
                            position="right"
                            text="All assets needed to modify this asset. Example: Blender/Max/Maya files, textures, PSD, AI, Premiere or AE project files">
                            <i class="material-icons notranslate"> help_outline </i>
                        </vx-tooltip>
                    </div>
                </template>

                <div>
                    <vue-dropzone ref="dropzoneSource"
                                  id="dropzone_source"
                                  :options="dropzoneOptions"
                                  :use-custom-slot="true"
                                  v-on:vdropzone-file-added="(file)=>{fileAdded([file],'thumbnail')}"
                                  v-on:vdropzone-success="(file)=>{fileSuccess(file,'thumbnail')}"
                                  v-on:vdropzone-error="(file)=>{fileError(file,'thumbnail')}"
                                  class="custom-input add-variant-images-block">

<!--                            <div id="source-images" style="margin-top: 5px;">-->
<!--                                <div class="con-input-upload">-->
<!--                                    <input type="file"-->
<!--                                           ref="fileuploadT"-->
<!--                                           @change="(event)=>{fileAdded(event.target.files,'thumbnail')}"-->
<!--                                    >-->
<!--                                    <span class="text-input">Upload File</span>-->
<!--                                    <span class="input-progress" style="width: 0%;"></span>-->
<!--                                    <button disabled="disabled" type="button" title="Upload" class="btn-upload-all vs-upload&#45;&#45;button-upload">-->
<!--                                        <i translate="translate" class="material-icons notranslate">cloud_upload</i>-->
<!--                                    </button>-->
<!--                                </div>-->
<!--                            </div>-->

                      <resumable-upload v-on:abort="abortResumableUpload" title="Upload thumbnail" type="thumbnail" v-on:addUploadedFile="addUploadedFile" v-if="isResumableUpload"></resumable-upload>
                        <custom-upload :images="thumbnail" index="thumbnail"
                                       :isDelete="!this.item.thumbnail || this.thumbnail[0] && this.item.thumbnail !== this.thumbnail[0]"
                                       v-if="thumbnail && thumbnail.length > 0"
                                       v-on:deleteImage="deleteImage"></custom-upload>
                    </vue-dropzone>
                </div>
            </vx-input-group>
            <vx-input-group class="mb-4 custom-input-group upload-block">
                <template slot="prepend">
                    <div class="label-with-tooltip" style="align-items: center">
                        <div class="prepend-text bg-dark" style="padding: .7rem !important;">
                            Source Files
                        </div>
                        <vx-tooltip
                            class="help-tip"
                            position="right"
                            text="All assets needed to modify this asset. Example: Blender/Max/Maya files, textures, PSD, AI, Premiere or AE project files">
                            <i class="material-icons notranslate"> help_outline </i>
                        </vx-tooltip>
                    </div>
                </template>

                <div>
                    <vue-dropzone ref="dropzoneSource"
                                  id="dropzone_source2"
                                  :options="dropzoneOptions"
                                  :use-custom-slot="true"
                                  v-on:vdropzone-file-added="(file)=>{fileAdded([file],'source_links')}"
                                  v-on:vdropzone-success="(file)=>{fileSuccess(file,'source_links')}"
                                  v-on:vdropzone-error="(file)=>{fileError(file,'source_links')}"
                                  class="custom-input add-variant-images-block">
                        <div>
                            <div class="con-upload">
                                <div class="con-img-upload">
                                    <div class="con-input-upload" id="source_url-import-url"
                                         @click="activePromptSource = true">
                                        <span class="text-input"> Import Url </span>
                                        <button type="button" title="Import"
                                                class="btn-upload-all vs-upload--button-upload">
                                            <feather-icon icon="LinkIcon"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <vs-prompt
                                class="add-variant-url"
                                title="Enter file url"
                                @cancel="source_url=''"
                                @accept="importFileFromUrl('source_url', 'source_links')"
                                @close="source_url=''"
                                :active.sync="activePromptSource">
                                <div class="con-exemple-prompt">
                                    <vs-input placeholder="File Url..." vs-placeholder="Code" v-model="source_url"
                                              class="mt-3 w-full"/>
                                </div>
                            </vs-prompt>
                        </div>
<!--                          <div id="source-images" style="margin-top: 5px;">-->
<!--                              <div class="con-input-upload">-->
<!--                                  <input type="file"-->
<!--                                         multiple-->
<!--                                         ref="fileuploadL"-->
<!--                                         @change="(event)=>{fileAdded(event.target.files,'source_links')}"-->
<!--                                  >-->
<!--                                  <span class="text-input">Upload File</span>-->
<!--                                  <span class="input-progress" style="width: 0%;"></span>-->
<!--                                  <button disabled="disabled" type="button" title="Upload" class="btn-upload-all vs-upload&#45;&#45;button-upload">-->
<!--                                      <i translate="translate" class="material-icons notranslate">cloud_upload</i>-->
<!--                                  </button>-->
<!--                              </div>-->
<!--                          </div>-->
                        <div id="source-images2" style="margin-top: 5px;" v-if="!isResumableUpload">
                            <div class="con-input-upload">
                                <input type="file"
                                       ref="fileuploadL"
                                       @change="(event)=>{fileAdded(event.target.files,'source_links', true)}"
                                >
                                <span class="text-input">Upload File</span>
                                <span class="input-progress" style="width: 0%;"></span>
                                <button disabled="disabled" type="button" title="Upload" class="btn-upload-all vs-upload--button-upload">
                                    <i translate="translate" class="material-icons notranslate">cloud_upload</i>
                                </button>
                            </div>
                        </div>

                      <resumable-upload v-on:abort="abortResumableUpload" title="Upload File" type="source_links" v-on:addUploadedFile="addUploadedFile" v-if="isResumableUpload"></resumable-upload>

                        <custom-upload :images="source_links" index="source_links"
                                       :is-delete="$store.state.user.role.name === 'Manager'"
                                       v-if="source_links && source_links.length > 0"
                                       v-on:deleteImage="deleteImage"></custom-upload>
                    </vue-dropzone>
                </div>
            </vx-input-group>
            <vx-input-group class="mb-4 custom-input-group upload-block">
                <template slot="prepend">
                    <div class="label-with-tooltip" style="align-items: center">
                        <div class="prepend-text bg-dark" style="padding: .7rem !important;">
                            Coobo-ready files
                        </div>
                        <vx-tooltip
                            class="help-tip"
                            position="right"
                            text="Output media. Example: JPG, PNG, MP4, WebM, FBX, GLTF">
                            <i class="material-icons notranslate"> help_outline </i>
                        </vx-tooltip>
                    </div>
                </template>

                <vue-dropzone ref="dropzoneSource"
                              id="dropzone_ready"
                              :options="dropzoneOptions"
                              :use-custom-slot="true"
                              v-on:vdropzone-file-added="(file)=>{fileAdded([file],'ready_links')}"
                              v-on:vdropzone-success="(file)=>{fileSuccess(file,'ready_links')}"
                              v-on:vdropzone-error="(file)=>{fileError(file,'ready_links')}"

                              v-on:click="(event)=>{consoel.log('event',event)}"
                              class="custom-input add-variant-images-block">

                    <div>
                        <div class="con-upload">
                            <div class="con-img-upload">
                                <div class="con-input-upload" id="ready_url-import-url" @click="activePromptReady = true">
                                    <span class="text-input"> Import Url </span>
                                    <button type="button" title="Import"
                                            class="btn-upload-all vs-upload--button-upload">
                                        <feather-icon icon="LinkIcon"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <vs-prompt
                            class="add-variant-url"
                            title="Enter file url"
                            @cancel="ready_url=''"
                            @accept="importFileFromUrl('ready_url', 'ready_links')"
                            @close="ready_url=''"
                            :active.sync="activePromptReady">
                            <div class="con-exemple-prompt">
                                <vs-input placeholder="File Url..." vs-placeholder="Code" v-model="ready_url"
                                          class="mt-3 w-full"/>
                            </div>
                        </vs-prompt>
                    </div>

                    <div id="ready-images" style="margin-top: 5px;" v-if="!isResumableUpload">
                        <div class="con-input-upload">
                            <input type="file"
                                   multiple
                                   ref="fileupload"
                                   @change="(event)=>{fileAdded(event.target.files,'ready_links')}"
                            >
                            <span class="text-input">Coobo-ready Files</span>
                            <span class="input-progress" style="width: 0%;"></span>
                            <button disabled="disabled" type="button" title="Upload" class="btn-upload-all vs-upload--button-upload">
                                <i translate="translate" class="material-icons notranslate">cloud_upload</i>
                            </button>
                        </div>
                    </div>
                  <resumable-upload v-on:abort="abortResumableUpload" title="Coobo-ready Files" type="ready_links" v-on:addUploadedFile="addUploadedFile" v-if="isResumableUpload"></resumable-upload>

                  <custom-upload :images="ready_links" index="ready_links" v-if="ready_links && ready_links.length > 0"
                                   :is-delete="$store.state.user.role.name === 'Manager'"
                                   v-on:deleteImage="deleteImage"></custom-upload>
                </vue-dropzone>
                <span class="text-danger text-sm validation-error source-files-validaton"
                      v-show="isSaveClicked && ((!ready_links || !ready_links.length) && (!source_links || !source_links.length))"
                      v-if="asset && asset.asset_type === '3D'">The source or ready files field is required</span>
            </vx-input-group>
            <vx-input-group class="mb-4 custom-input-group upload-block">
                <template slot="prepend">
                    <div class="label-with-tooltip" style="align-items: center">
                        <div class="prepend-text bg-dark" style="padding: .7rem !important;">
                            Ar ready files
                        </div>
<!--                          <vx-tooltip-->
<!--                              class="help-tip"-->
<!--                              position="right"-->
<!--                              text="Output media. Example: JPG, PNG, MP4, WebM, FBX, GLTF">-->
<!--                              <i class="material-icons notranslate"> help_outline </i>-->
<!--                          </vx-tooltip>-->
                    </div>
                </template>

                <vue-dropzone ref="dropzoneSource"
                              id="dropzone_ready3"
                              :class="{'ignore-no-edit': $store.state.user.role.name === 'Media'}"
                              :options="dropzoneOptions"
                              :use-custom-slot="true"
                              v-on:vdropzone-file-added="(file)=>{fileAdded([file],'ar_links')}"
                              v-on:vdropzone-success="(file)=>{fileSuccess(file,'ar_links')}"
                              v-on:vdropzone-error="(file)=>{fileError(file,'ar_links')}"

                              v-on:click="(event)=>{console.log('event',event)}"
                              class="custom-input add-variant-images-block">

                    <div>
                        <div class="con-upload">
                            <div class="con-img-upload">
                                <div class="con-input-upload" id="ar_url-import-url" @click="activePromptAr = true">
                                    <span class="text-input"> Import Url </span>
                                    <button type="button" title="Import"
                                            class="btn-upload-all vs-upload--button-upload">
                                        <feather-icon icon="LinkIcon"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <vs-prompt
                            class="add-variant-url"
                            title="Enter file url"
                            @cancel="ar_url=''"
                            @accept="importFileFromUrl('ar_url', 'ar_links')"
                            @close="ar_url=''"
                            :active.sync="activePromptAr">
                            <div class="con-exemple-prompt">
                                <vs-input placeholder="File Url..." vs-placeholder="Code" v-model="ar_url"
                                          class="mt-3 w-full"/>
                            </div>
                        </vs-prompt>
                    </div>

                    <div id="ra-images" style="margin-top: 5px;" v-if="!isResumableUpload">
                        <div class="con-input-upload">
                            <input type="file"
                                   multiple
                                   ref="fileupload"
                                   @change="(event)=>{fileAdded(event.target.files,'ar_links')}"
                            >
                            <span class="text-input">Ar ready Files</span>
                            <span class="input-progress" style="width: 0%;"></span>
                            <button disabled="disabled" type="button" title="Upload" class="btn-upload-all vs-upload--button-upload">
                                <i translate="translate" class="material-icons notranslate">cloud_upload</i>
                            </button>
                        </div>
                    </div>
                  <resumable-upload v-on:abort="abortResumableUpload" title="Ar ready Files" type="ar_links" v-on:addUploadedFile="addUploadedFile" v-if="isResumableUpload"></resumable-upload>

                  <custom-upload :images="ar_links" index="ar_links" v-if="ar_links && ar_links.length > 0"
                                   :is-delete="$store.state.user.role.name === 'Manager'"
                                   v-on:deleteImage="deleteImage"></custom-upload>
                </vue-dropzone>
            </vx-input-group>
            <div class="mb-4 d-flex justify-between">
                  <div class="d-flex align-center">
                      <vx-input-group v-if="asset && asset.asset_type === '3D'">
                          <div class="vs-con-loading__container"
                               :class="{'pen': !(item.name && ready_links && ready_links.length > 0)}"
                          >
                              <vs-button class="mr-2 shadow-lg" type="gradient" style="margin-top: 2px"
                                         @click="generateFromReadyFiles" id="generate-from-crf-btn"
                                         :disabled="!(item.name && ready_links && ready_links.length > 0)">Process Asset
                              </vs-button>
                          </div>
                      </vx-input-group>
                      <a :href="item.coobo_library_link.replace(/view_asset/gi, 'edit_asset')" target="_blank" v-if="item.coobo_library_link" style="margin-top: 2px">
                          <vs-button class="shadow-lg" type="gradient">
                              Edit Asset Materials
                          </vs-button>
                      </a>
                  </div>
                  <i class="material-icons"  @click="refreshIframe" v-if="item.coobo_library_link" style="font-size: 41px; cursor: pointer"> refresh </i>
              </div>
            <vx-input-group class="flex-grow mb-4" v-if="asset && asset.asset_type === '3D'">
              <template slot="prepend">
                <div class="label-with-tooltip">
                  <div class="prepend-text bg-dark">
                    Coobo library link
                  </div>
                  <vx-tooltip
                    class="help-tip"
                    position="right"
                    text="Link to the asset as uploaded to the Coobo Asset Library">
                    <i class="material-icons notranslate"> help_outline </i>
                  </vx-tooltip>
                </div>
              </template>

              <div class="d-flex coobo-library-link-wrapper">
                <vs-input
                  name="coobo_library_link"
                  placeholder="Name"
                  v-model="item.coobo_library_link"
                />
                <span class="text-danger text-sm validation-error" v-show="errors.has('coobo_library_link')">The coobo library link field must contain "https://coobo.embibe.com/api/view_asset/"</span>

              </div>
            </vx-input-group>

              <!--            <vx-input-group class="custom-input-group mb-4"-->
              <!--                            v-if="item.coobo_library_link && !errors.has('coobo_library_link')">-->
              <!--                <div class="d-flex">-->
              <!--                    <div class="vs-con-loading__container">-->
              <!--                        <a :href="item.coobo_library_link.replace(/view_asset/gi, 'edit_asset')" target="_blank">-->
              <!--                            <vs-button class="mr-2 shadow-lg" type="gradient" style="margin-top: 2px">Materials</vs-button>-->
              <!--                        </a>-->
              <!--                    </div>-->
              <!--                    <div class="vs-con-loading__container">-->
              <!--                        <a :href="item.coobo_library_link.replace(/view_asset/gi, 'edit_hierarchy_translation')" target="_blank">-->
              <!--                            <vs-button class="mr-2 shadow-lg" type="gradient" style="margin-top: 2px">Labels & Translation</vs-button>-->
              <!--                        </a>-->
              <!--                    </div>-->
              <!--                </div>-->
              <!--            </vx-input-group>-->
              <vx-input-group class="custom-input-group mb-4"
                              v-if="item.coobo_library_link && !errors.has('coobo_library_link')">
                  <iframe ref="libraryIframe" class="library-iframe" :src="item.coobo_library_link + '?hq'" allowfullscreen></iframe>
              </vx-input-group>

              <vs-popup class="holamundo" title="ASSET VALIDATION WARNING" :active.sync="validationPopup">
                  <div v-if="validationErrorMessage">
                      <b>Blender error:</b> {{validationErrorMessage}}
                  </div>
                  <div v-for="(rule, i) in validationErrorData" :key="i" class="validation-rule-row" v-if="validationErrorData.length">
                      <div class="d-flex">
                          <vs-icon icon="done" color="success" v-if="rule.passed"/>
                          <vs-icon icon="clear" color="danger" v-if="!rule.passed"/>
                          <div class="message">{{rule.message}}</div>
                      </div>
                  </div>
                  <div class="validation-info">Asset was still imported, but please consult
                      <a href='https://embibesupport.zendesk.com/hc/en-us/articles/360041248393-3D-Asset-Specifications'
                         target="_blank" rel="noopener noreferrer">Help Centre</a> for asset specification.</div>
              </vs-popup>
          </div>
      </div>
      <div class="popup-footer">
          <div class="vs-con-loading__container">
              <vs-button class="mr-2 shadow-lg" type="gradient" id="add-variant-save-btn" @click="save"
                         style="margin-top: 2px">Save
              </vs-button>
          </div>
      </div>
    </vs-popup>
</template>

<script>
  const Url = 'https://embibesupport.zendesk.com/hc/en-us/articles/360041248393-3D-Asset-Specifications';

  const LinkProps = { target: '_blank', rel: 'noopener noreferrer' };
  import vSelect from 'vue-select'
  import customUpload from '../customUpload.vue'
  import vue2Dropzone from 'vue2-dropzone'
  import processingAsset from '../ProcessingAsset.vue'
  import resumableUpload from '../ResumableUpload.vue'

  export default {
    components: {
      vSelect,
      customUpload,
      vueDropzone: vue2Dropzone,
      processingAsset,
      resumableUpload
    },
    props: {
      edit_item: Object,
      updateAsset: {
        type: Function,
        required: false,
      },
      asset: {
        type: Object,
        default: null
      },
      visualStyles: Array
    },
    data() {
      return {
        dropzoneOptions: {
          clickable: false,
          autoProcessQueue: false,
          url: this.$store.state.appUrl + '/' + this.$store.state.filesUrl,
          previewTemplate: `<div></div>`
        },
        libraryLinkDebounce: null,
        isSaveClicked: false,
        headers: {Authorization: 'Bearer ' + localStorage.getItem('jwt')},
        activePromptSource: false,
        activePromptReady: false,
        activePromptAr: false,
        source_url: "",
        ready_url: "",
        ar_url: "",
        isLoading: 0,
        popupActive: true,
        isAction: false,
        isLibraryIframe: false,
        item: null,
        hasChanges: false,
        validationPopup: false,
        validationErrorMessage: null,
        validationErrorData: [],
        languages: [
          {label: 'None', value: "None"},
          {label: 'English', value: "English"},
          {label: 'Hindi', value: "Hindi"},
        ],
        source_links: [],
        ready_links: [],
        ar_links: [],
        thumbnail: [],
        isVariationOverlay: false,
        currentLanguage: {
          name: 'None',
          code: 'none'
        },
        isResumableUpload: true
      }
    },
    mounted() {
      this.popupActive = true;
      if (this.edit_item) {
        let d = this.edit_item;
        if (d.language === 'None') {
          d.language = 'none';
        } else if (d.language === 'English') {
          d.language = 'en';
        } else if (d.language === 'Hindi') {
          d.language = 'hi'
        }
        if (d.language === 'en') {
          this.currentLanguage = { name: 'English', code: 'en' };
        } else if (d.language !== 'none') {
          let lang = this.$store.state.languages.find(item => item.code === d.language);
          if (lang) {
            this.currentLanguage = lang;
          }
        }

        this.item = d;

        if (this.item.thumbnail && this.item.thumbnail.length > 0) {
          this.thumbnail = [this.item.thumbnail];
        }
        if (this.item.source_links && this.item.source_links.length > 0) {
          this.source_links = this.item.source_links;
        }
        if (this.item.ready_links && this.item.ready_links.length > 0) {
          this.ready_links = this.item.ready_links;
        }
        if (this.item.ar_links && this.item.ar_links.length > 0) {
          this.ar_links = this.item.ar_links;
        }
      } else {
        this.item = {
          "name": this.asset ? this.asset.title : "",
          "approved_by": "",
          "updated_at": '',
          "coobo_library_link": "",
          "coobo_ready": false,
          "is_animated": false,
          "language": "none",
          "ready_links": null,
          "ar_links": null,
          "output_size": 0,
          "poly_count": 0,
          "source_links": null,
          "source_size": 0,
          "thumbnail": null,
          "visual_style": ''
        };
      }
    },
    destroyed() {
      clearInterval(this.libraryLinkDebounce);
    },
    watch: {
      popupActive() {
        if (!this.popupActive) {
            this.closeModal();
        }
      }
    },
    methods: {
      changeLanguage(v) {
        this.item.language = v.code;
      },
      refreshIframe() {
          // this.$refs.libraryIframe.contentWindow.location.reload();
          this.$refs.libraryIframe.src = this.$refs.libraryIframe.src;
      },
      fileSuccess(file){
        console.log('fileSuccess',file);
      },
      fileError(file){
        this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Upload failed'})
      },
      fileAdded(files, type, isLargeFile) {

        files.forEach((f) => {
          let name = f.name.split(".");
          let ext = "." + name.pop();
          name = name.join(".");

          let formData = new FormData();
          formData.append("files", f);
          this.changeUploadImages();

          let CancelToken = this.$axios.CancelToken;
          let source = CancelToken.source();
          let config = {
            onUploadProgress: progressEvent => {
              tempLink.percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            },
            cancelToken: source.token
          };

          let tempLink = {name, ext, loading: true, url: "", percentCompleted: 0, source};

          this[type].push(tempLink)

          let url = isLargeFile ? 'upload-large-file' : this.$store.state.filesUrl
          this.$axios.post('/' + url, formData, config).then(res => {
            let ind = this[type].indexOf(tempLink);
            if (ind !== -1) {
              this[type].splice(ind, 1);
              this[type].push(...res.data);
            }
            this.onUploaded(res.data.length, false, false, `${f.name} uploaded successfully`);
          }).catch(e => {
            if (this.$axios.isCancel(e)) {
              this.onUploaded(1, { message: `${e.message} Request canceled`});
            } else{
              this.onUploaded(1, true, false, e.message ? e.message : `${f.name} upload failed`);
            }
          })
        });
      },
      log(a1, a2, a3, a4, a5) {
        [...arguments].forEach(a => {
          a && console.log(a);
        })
      },
      showFolderWarn() {
        clearTimeout(this.folderWarnTimeout)
        this.folderWarnTimeout = setTimeout(() => {
          this.$vs.dialog({
            color: "warning",
            title: `Folders are not supported`,
            text: 'Folders are not supported. Your files will be uploaded,  but folder structure will be lost.',
            acceptText: "OK"
          })
        }, 200)
      },
      handleLibraryIframe() {
        if (this.item.coobo_library_link && !this.errors.has('coobo_library_link')) {
          this.isLibraryIframe = true;
        } else {
          this.isLibraryIframe = false;
        }
      },
      changeUploadImages() {
        this.isLoading++;
        this.hasChanges = true;
        this.$root.addLoading('#add-variant-save-btn');
        this.$root.addLoading('#generate-from-crf-btn');
      },
      getDateFormat(date) {
          let d = new Date(date);
          return (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " +
              d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
      },
      save() {
        this.isSaveClicked = true;
        this.$validator.validateAll().then(valid => {
          const afterAssetIsValid = () => {
            if (!this.asset || this.asset.asset_type !== '3D' || (this.ready_links.length || this.source_links.length)) {
              this.$root.addLoading('#add-variant-save-btn');
              this.popupActive = false;
              this.isAction = true;
            } else {
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Fill all fields'})
            }
          }
          if (valid && (!this.asset || this.asset.asset_type !== '3D' || (this.ready_links.length || this.source_links.length)) ) {
            this.isAction = true;
            this.$root.addLoading('#add-variant-save-btn');

            this.closeModal(true).then(res => {
                let vIds = this.asset.variants.map(item => item._id);
                if (vIds.indexOf(this.item._id) === -1) {
                    vIds.push(this.item._id);
                }
                this.updateAsset({
                    force: true,
                    forceUpdateAsset: true,
                    variants: vIds,
                    noRedirect: true,
                    cb: (asset) => {
                        if (!this.$route.params.id) {
                            history.pushState(
                                {},
                                null,
                                `/${asset._id}/edit`
                            )
                            this.$route.params.id = asset._id;
                        }
                        if (!this.asset._id) {
                            this.asset._id = asset._id;
                        }
                        this.isAction = false;
                        this.popupActive = false;
                    }
                })
            })
          }

        })


      },
      importFileFromUrl(urlObj, targetArr) {
        this.$root.addLoading('#' + urlObj + '-import-url');
        this.hasChanges = true;
        let url = this[urlObj];
        this[urlObj] = '';
        this.changeUploadImages();
        this.$axios.post('/assets/import-url', {url: url}).then(res => {
          let showError = false;
          for (let k in res.data) {
            if (res.data[k].error) {
              showError = true;
            } else {
              this[targetArr].push(res.data[k]);
            }
          }
          this.$root.removeLoading('#' + urlObj + '-import-url');
          this.onUploaded(1, showError, false, `${url} uploaded successfully`);
        }).catch(e => {
          this.$root.removeLoading('#' + urlObj + '-import-url');
          this.onUploaded(1, true, false, e.message ? e.message : `${url} upload failed`);
          this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Import Error', text: e.message || e})
        });
      },
      closeModal(withoutClose, withoutQueue) {
        let variation = null;
        if (this.isAction) {
          let item = this.item;
          let thumbnail = this.thumbnail;
          let source_files = this.source_links;
          let source_links = source_files.filter((item, index) => source_files.indexOf(item) === index)
          let ready_files = this.ready_links;
          let ready_links = ready_files.filter((item, index) => ready_files.indexOf(item) === index)
          let ar_files = this.ar_links;
          let ar_links = ar_files.filter((item, index) => ar_files.indexOf(item) === index)
          let source_size = 0;
          let ready_size = 0;
          let ar_size = 0;

          if (source_links.length > 0) {
            item.source_links = source_links
          }
          if (ready_links.length > 0) {
            item.ready_links = ready_links
          }
          if (ar_links.length > 0) {
            item.ar_links = ar_links
          }
          item.thumbnail = thumbnail.length > 0? thumbnail[0].url ? thumbnail[0].url : thumbnail[0]: this.item.thumbnail ? this.item.thumbnail : null;
          if (item.source_links && item.source_links.length > 0) {
            for (let k in item.source_links) {
              source_size += item.source_links[k].size;
            }
          }
          if (item.ready_links && item.ready_links.length > 0) {
            for (let k in item.ready_links) {
              ready_size += item.ready_links[k].size;
            }
          }
          if (item.ar_links && item.ar_links.length > 0) {
            for (let k in item.ar_links) {
              ar_size += item.ar_links[k].size;
            }
          }
          item.source_size = source_size;
          item.output_size = ready_size;
          item.ar_size = ar_size;
          item.approved_by = this.$store.state.user.email;
          if (item.assets && item.assets.length > 0) {
            let temp = [];
            item.assets.forEach(item => {
                if (item) {
                    temp.push(item._id);
                }
            })

            item.assets = temp;
          }
          // if (item.hasOwnProperty('thumbnail')) {
          //     delete item.thumbnail;
          // }

          if (this.asset) {
              if (this.asset.asset_type) {
                  item.asset_type = this.asset.asset_type;
              }
              item.asset = this.asset._id;
          }
          if (item.coobo_library_link_priority_queue && !item.coobo_library_link_priority_queue._id) {
              delete item.coobo_library_link_priority_queue;
          }
          if (item._id) {
            let url = '/variants/' + item._id;

            return this.$axios.put(url, item).then(res => {
              variation = {
                item: res.data,
              }

              if (!withoutClose) {
                setTimeout(() => {
                  this.$emit('closeAddVariation', variation);
                }, 1)
              } else {
                this.item = res.data
              }
            }).catch(e => {
              console.log('catch_search', e)
                setTimeout(() => {
                    this.$root.removeLoading('#add-variant-save-btn');
                }, 100)
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Failed save variation'})
            })
          } else {
            let url = '/variants';
            if (withoutQueue) {
                item.withoutQueue = true;
            }

            return this.$axios.post(url, item).then(res => {
              variation = {
                item: res.data,
              }
              if (!withoutClose) {
                setTimeout(() => {
                  this.$root.removeLoading('#add-variant-save-btn');

                  this.$emit('closeAddVariation', variation);
                }, 1)
              } else {
                this.item = res.data
              }
            }).catch(e => {
              console.log('catch_search', e)
                setTimeout(() => {
                    this.$root.removeLoading('#add-variant-save-btn');
                }, 100)
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Failed save variation'})
            })
          }
        } else {
          setTimeout(() => {
            this.$root.removeLoading('#add-variant-save-btn');

            this.$emit('closeAddVariation', variation);
          }, 1)
        }
      },
      onUploaded(count, err, noMsg, messageText) {
        this.isLoading -= count;
        if (this.isLoading <= 0) {
          this.isLoading = 0;
          this.$root.removeLoading('#add-variant-save-btn');
          this.$root.removeLoading('#generate-from-crf-btn');
          // this.$refs.fileuploadT.value = '';
          this.$refs.fileupload.value = '';
          this.$refs.fileuploadL.value = '';

          this.$refs.dropzoneSource.removeAllFiles();
        }
        if (err) {
          this.$vs.notifyWrapper({
            color: 'danger',
            fixed: true,
            title: err.title || "Error",
            text: messageText ? messageText : err.message || "Wrong file link"
          })
        } else if (!noMsg) {
          this.$vs.notifyWrapper({color: 'success', fixed: true, title: messageText || 'Upload Successful'})
        }
      },
      deleteImage(data) {
        let images = this[data.index];
        console.log(images)
        if(data.item.loading){
          data.item.source.cancel(data.item.name);
        }
        let index = images.indexOf(data.item);
        if (index > -1) {
          images.splice(index, 1);
          this[data.index] = images;
          if (data.item.loading) {
            this.onUploaded(1, false, true);
          }
        }
      },
      cancel() {
        this.popupActive = false
      },
      getVariantData() {
          let url = '/variants/' + this.item._id;

          this.$axios.get(url).then(res => {
              setTimeout(() => {
                  if (this.item.coobo_library_link_priority_queue && res.data.coobo_library_link_priority_queue && this.item.coobo_library_link_priority_queue.status != res.data.coobo_library_link_priority_queue.status && (this.item.coobo_library_link_priority_queue.status != 'done' && this.item.coobo_library_link_priority_queue.status != 'error')) {
                      this.$set(this.item, 'coobo_library_link_priority_queue', res.data.coobo_library_link_priority_queue);
                      if (res.data.coobo_library_link_priority_queue && this.item.coobo_library_link_priority_queue.status == 'done') {
                          this.scrollToBottom();
                      }
                  }
                  if (res.data.coobo_library_link) {
                      this.item.coobo_library_link = res.data.coobo_library_link;
                      clearInterval(this.libraryLinkDebounce);
                  }
              }, 500)
          }).catch(err => {

          });
      },
      scrollToBottom() {
          this.$refs.scroll.scrollTop = this.$refs.scroll.scrollHeight
      },
      generateFromReadyFiles() {
        this.isSaveClicked = true;
        if (this.item.coobo_library_link_priority_queue) {
          this.$set(this.item, 'coobo_library_link_priority_queue', null)
        }
        this.isVariationOverlay = true;
        this.$validator.validateAll().then(result => {
          if (result && (!this.asset || this.asset.asset_type !== '3D' || (this.ready_links.length || this.source_links.length))) {
            this.isAction = true;
            this.$root.addLoading('#add-variant-save-btn');
            this.$root.addLoading('#generate-from-crf-btn');
            let getDataInverval = () => {
                let url = '/assets/generate-from-crf';

                let data = {
                    _id: this.item._id,
                };

                this.$axios.post(url, data).then(r => {
                  clearInterval(this.libraryLinkDebounce);
                  this.$root.removeLoading('#generate-from-crf-btn');
                  this.$root.removeLoading('#add-variant-save-btn');
                    if (r.data.error) {
                      this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: 'Coobo ready files must be: ' + r.data.extensions.join(", ") || "Coobo ready files type error"})
                    } else {
                      this.$set(this.item, 'coobo_library_link_priority_queue', {status: 'in_queue', updatedAt: new Date()})

                      this.libraryLinkDebounce = setInterval(() => {
                        let url = '/variants/' + this.item._id;

                        this.$axios.get(url).then(res => {
                          if (this.item.coobo_library_link_priority_queue && res.data.coobo_library_link_priority_queue && this.item.coobo_library_link_priority_queue.status != res.data.coobo_library_link_priority_queue.status && (this.item.coobo_library_link_priority_queue.status != 'done' && this.item.coobo_library_link_priority_queue.status != 'error')) {
                            this.$set(this.item, 'coobo_library_link_priority_queue', res.data.coobo_library_link_priority_queue)
                            if (res.data.coobo_library_link_priority_queue && this.item.coobo_library_link_priority_queue.status == 'done') {
                              this.scrollToBottom();
                            }
                          }
                          if (res.data.coobo_library_link && res.data.coobo_library_link_priority_queue && res.data.coobo_library_link_priority_queue.status !== 'in_progress') {
                            this.$root.removeLoading('#generate-from-crf-btn');
                            this.item.coobo_library_link = res.data.coobo_library_link;
                            clearInterval(this.libraryLinkDebounce);
                          }
                        }).catch(err => {
                          this.$root.removeLoading('#generate-from-crf-btn');
                          this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                        });
                      }, 10 * 1000);
                      this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Added to queue'})
                      this.$root.removeLoading('#add-variant-save-btn');
                    }
                }).catch(err => {
                    this.$root.removeLoading('#generate-from-crf-btn');
                    this.$root.removeLoading('#add-variant-save-btn');

                    this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: "Coobo ready files type error"})
                });
            }
            this.closeModal(true, true).then(() => {
              if (this.asset && this.asset._id) {
                  getDataInverval();
              } else {
                  this.updateAsset({
                      force: true,
                      variants: [...this.asset.variants, this.item._id],
                      noRedirect: true,
                      cb: (asset) => {
                          history.pushState(
                              {},
                              null,
                              `/${asset._id}/edit`
                          )
                          this.$route.params.id = asset._id;
                          this.asset._id = asset._id;
                          getDataInverval();
                      }
                  })
              }

            });
          } else {
            this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Fill all fields'})
          }
        })
        // return
        // this.validationErrorData = [];
        // this.validationErrorMessage = null;
        // this.$axios.post(url, data).then(res => {
        //   if (res.data.error) {
        //     if (res.data.error.validation && res.data.error.validation.passed === false && res.data.error.validation.rules && res.data.error.validation.rules.length) {
        //       res.data.error.message = "Validation error";
        //       this.validationErrorData = res.data.error.validation.rules;
        //       this.validationPopup = true;
        //     }
        //     if (!res.data.error.validation && res.data.error.blender && res.data.error.blender.stderr) {
        //       this.validationErrorMessage = res.data.error.blender.stderr;
        //       this.validationPopup = true;
        //     }
        //     this.onUploaded(1, {
        //       title: 'Upload failed',
        //       message: res.data.error.message || "Unknown error"
        //     });
        //   } else {
        //     if (res.data.status) {
        //       if (res.data.status.validation && res.data.status.validation.passed === false && res.data.status.validation.rules && res.data.status.validation.rules.length) {
        //         this.validationErrorData = res.data.status.validation.rules;
        //         this.validationPopup = true;
        //       }
        //     }
        //     this.item.coobo_library_link = res.data ? res.data.link : '';
        //     this.onUploaded(1);
        //   }
        //   this.$root.removeLoading('#generate-from-crf-btn');
        // }).catch(err => {
        //   console.log('catch_search', err.message);
        //   this.$root.removeLoading('#generate-from-crf-btn');
        //   this.onUploaded(1, err);
        // })
      },
      abortResumableUpload() {
        this.isResumableUpload = false;
      },
      addUploadedFile(data) {
        if (data.type === 'thumbnail') {
          this[data.type] = [data.data.url];
        } else {
          this[data.type].push(data.data);
        }
      }
    },
  }
</script>
<style>
    .con-vs-dialog {
        z-index: 53001
    }
</style>
